var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.625,
    height: 47.625,
    viewBox: "0 0 47.625 47.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient123",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M37.627,6.836a23.813,23.813,0,1,0,16.83,40.642,23.575,23.575,0,0,0,6.983-16.83A23.841,23.841,0,0,0,37.627,6.836ZM49.468,25.564l-13.708,13a2.078,2.078,0,0,1-1.352.515,1.752,1.752,0,0,1-1.352-.579L25.85,31.1a1.912,1.912,0,0,1,2.767-2.639l5.857,6.05L46.83,22.8a1.912,1.912,0,1,1,2.639,2.767Z",
    transform: "translate(-13.814 -6.836)",
    fill: "url(#linear-gradient123)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcheckmark);
export default __webpack_public_path__ + "static/media/acheckmark.7613408c99f76e52a6c33a7e3b4fdde3.svg";
export { ForwardRef as ReactComponent };